import { Skeleton } from '@ooh/ui/components/skeleton';

const SIDEBAR_CARD_IDS = ['card-1', 'card-2', 'card-3', 'card-4', 'card-5'];

export function DetailSkeleton() {
  return (
    <div className="p-6 max-w-6xl mx-auto" data-testid="skeleton-loading">
      <Skeleton className="h-5 w-32 mb-5" />
      <div className="flex items-start justify-between mb-5">
        <div>
          <Skeleton className="h-8 w-48 mb-2" />
          <Skeleton className="h-4 w-64" />
        </div>
        <Skeleton className="h-8 w-20" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-6">
          <Skeleton className="h-64 rounded-lg" />
          <Skeleton className="h-48 rounded-lg" />
          <Skeleton className="h-32 rounded-lg" />
        </div>
        <div className="space-y-4">
          {SIDEBAR_CARD_IDS.map((id) => (
            <Skeleton key={id} className="h-24 rounded-lg" />
          ))}
        </div>
      </div>
    </div>
  );
}
